import {Header} from "../components/Header";
import {useEffect, useRef, useState} from "react";
import ProgressBar from "react-scroll-progress-bar";
import {Line} from "rc-progress";
import ScrollAnimation from 'react-animate-on-scroll';
import {useLocation, useNavigate} from "react-router-dom";
import {Footer} from "../components/Footer";
import {getRandomInt, isPc, range, savePageVisit, sendRequest} from "../static/js/common";
import {Carousel} from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Fade} from "react-awesome-reveal";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Modal from 'react-modal';
import ReactPlayer from "react-player";
import {useDraggable} from "react-use-draggable-scroll";



const Image = ({item, index, navigate}) => {

  const [width, setWidth] = useState(isPc ? '10vw' : '100%')
  const [opacity, setOpacity] = useState(1)

  useEffect(() => {
    if(width === '30vw') {
      if(opacity === 1)
        setOpacity(0.1)
      const timeout = setTimeout(() => {
        if(opacity < 1)
          setOpacity(opacity + 0.01);
      }, 10)
      return () => clearTimeout(timeout)
    } else {
      setOpacity(1)
    }
  }, [opacity, width]);

  return (
    <div className={`${isPc ? 'works-img' : 'mobile-works-img'}`}
         onClick={() => navigate(`/work-detail/${item?.id}`)}
         onMouseEnter={() => isPc && setWidth('30vw')}
         onMouseLeave={() => isPc && setWidth('10vw')}
    >
      <img style={{width, opacity}} src={width === '30vw' ? item?.bigThumbnail : item?.thumbnail}/>
    </div>
  )
}

// const Portfolio = ({item, index, navigate, isBig}) => {
//
//   return (
//     <div
//       className={'works-portfolio-wrapper'}
//       style={{marginRight: isPc ? index % 4 === 3 ? 0 : '0.5vw' : 0, marginBottom: isPc ? '2vw' : '30px'}}
//       onClick={() => navigate(`/work-detail/${item?.id}`)}
//     >
//       <div>
//         <img className={`${isBig ? 'big-works-portfolio-img' : 'works-portfolio-img'}`} src={item?.mainListImage}/>
//       </div>
//       <div className={'margin-top-15 text-left'}>
//         <div className={'more-blur-white font-14'}>{item?.client}</div>
//         <div className={'blur-white font-14 notosans-light margin-top-5'}>{item?.name}</div>
//       </div>
//     </div>
//   )
// }

const Portfolio = ({item, index, navigate, isHorizontal, setPortfolio, setModalOpen}) => {

  const [hover, setHover] = useState(false)

  return (
    <div
      className={'works-portfolio-wrapper'}
      style={{}}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => {
        if(isPc) {
          setPortfolio(item)
          setModalOpen(true)
        } else {
          navigate(`/work-detail/${item?.id}`)
        }
      }}
    >
      {/*<Fade direction={'right'} style={{margin: 0, padding: 0}}>*/}
      <img className={`${isHorizontal ? 'horizontal-works-portfolio-img' : 'vertical-works-portfolio-img'} works-portfolio-img`} src={isHorizontal ? item?.mainListImage : item?.mainVerticalImage ? item?.mainVerticalImage : item?.mainListImage}/>
      {/*</Fade>*/}
      {hover &&
        <div className={`relative absolute ${isHorizontal ? 'horizontal-works-dim' : 'vertical-works-dim'}`} style={{top: 0, left: 0}}>
        </div>
      }
      {hover &&
        <div className={'absolute'} style={{bottom: 0, right: 0}}>
          <img className={`works-hover-x`} src={require('../assets/images/hover_x.png')}/>
        </div>
      }
    </div>
  )
}

const MobilePortfolio = ({item, index, navigate}) => {

  return (
    <div
      className={'works-portfolio-wrapper'}
      style={{marginRight: isPc ? index % 4 === 3 ? 0 : '0.5vw' : 0, marginBottom: isPc ? '2vw' : '30px'}}
      onClick={() => navigate(`/work-detail/${item?.id}`)}
    >
      <div>
        <img className={`${isPc ? 'works-portfolio-img' : 'mobile-works-portfolio-img'}`} src={item?.mainListImage}/>
      </div>
      <div className={'white-border-left margin-top-15 text-left'} style={{paddingLeft: 6, marginLeft: 5}}>
        <div className={'more-blur-white font-14'}>{item?.client}</div>
        <div className={'blur-white font-14 notosans-light margin-top-5'}>{item?.name}</div>
      </div>
    </div>
  )
}

const ModalPortfolio = ({item, index, setPortfolio, scrollRef}) => {
  const [hover, setHover] = useState(false)
  const isActive = item?.id === item?.id

  return (
    <div
      key={`modal-portfolio-${item?.id}`}
      onClick={() => {
        setPortfolio(item)
        scrollRef?.current.scrollIntoView()
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={`modal-portfolio-img relative`}
      style={{zIndex: 9}}
    >
      <img className={`modal-portfolio-img`} src={item?.mainListImage}/>
      {hover && <div className={'modal-portfolio-red-box'}/>}
    </div>
  )
}

const ModalComponent = ({portfolio, setPortfolio, portfolios, setModalOpen, scrollRef}) => {

  const carouselRef = useRef(null);
  const [mouseOver, setMouseOver] = useState(false);
  const [index, setIndex] = useState(0);

  return (
    <div ref={scrollRef} className={'portfolio-modal-wrapper darkgray-bg'}>
      <div className={'absolute'} style={{right: '2vw', top: '2vh'}}>
        <div onClick={() => setModalOpen(false)}
             // onMouseEnter={() => isPc && setMouseOver(true)}
             // onMouseLeave={() => isPc && setMouseOver(false)}
        >
          <img className={'icon-36'} src={require('../assets/images/cancel.png')}/>
        </div>
      </div>
      <div style={{padding: '6vh 3vw 0 3vw'}}>
        <div className={`${isPc ? 'margin-top-10' : 'margin-top-32'}`}>
          <div style={{overflow: 'hidden'}}>
            {portfolio?.mainDetailImage ?
              <img style={{width: '100%', overflow: 'hidden'}} src={portfolio?.mainDetailImage}/>
              :
              <ReactPlayer playing={true} width={'100%'} height={'46.25vw'}
                           url={`https://www.youtube.com/watch?v=${portfolio?.youtubeId}`}/>
            }
          </div>
        </div>
        <div className={`${isPc ? 'flex-row-wo-center' : 'flex-column'} margin-top-20`}>
          <div className={`white bold notosans-black ${isPc ? '' : 'flex-row-wo-center'}`}
               style={{fontSize: 40}}>
            <div className={'flex-1'}>{portfolio?.name}</div>
          </div>
          <div className={`flex-row ${isPc ? 'margin-top-10' : 'margin-top-8'} margin-left-10 flex-1`}>
            {portfolio?.tags?.map((item, index) => {
              return (
                <div className={'red-badge notosans-black margin-right-8'}
                     style={{backgroundColor: item?.backgroundColor, fontSize: 20}}>{item?.name}</div>
              )
            })}
          </div>
        </div>
        <div className={`portfolio-desc-wrapper ${isPc ? 'margin-top-20' : 'flex-column margin-top-20'}`}>
          <div className={'flex-1 flex-row'}>
            <div className={'flex-1 flex-row'}>
              <div className={'blur-white font-16'}>Client</div>
              <div className={'white margin-top-3 font-16 margin-left-22'}>{portfolio?.client}</div>
              <div className={'blur-white font-16'} style={{marginLeft: 80}}>Services</div>
              <div className={'white margin-top-3 font-16 margin-left-22'}>{portfolio?.services}</div>
            </div>
          </div>
          <div className={`${isPc ? 'flex-start' : 'flex-start'}`} style={{marginTop: isPc ? 24 : 40}}>
            <div className={'white font-16 pre-wrap'} style={{lineHeight: 1.8}}>
              {portfolio?.description}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '0%',
    width: '100vw',
    height: '100%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#252525',
    zIndex: 9999,
    position: 'relative',
    overflow: 'auto'
  },
};

export const Works = ({}) => {

  const navigate = useNavigate()

  const carouselRef = useRef(null);
  // const categoryRef = useRef(null);
  const location = useLocation()

  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState({});
  const [showCategory, setShowCategory] = useState(false);
  const [portfolios, setPortfolios] = useState([]);
  const [index, setIndex] = useState(0);
  const [portfolio, setPortfolio] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const scrollRef = useRef(null)
  const [isLoading, setIsLoading] = useState(true);
  const { events } = useDraggable(carouselRef);
  // const { events : categoryEvents } = useDraggable(categoryRef);

  useEffect(() => {
    if(location?.state?.portfolio) {
      setPortfolio(location?.state.portfolio);
      setModalOpen(true)
    } else {
      setModalOpen(false)
    }
  }, [location?.state]);

  const getCategories = () => {
    sendRequest('portfolio/category/?size=100', 'GET', null, data => {
      setCategories(data);
      setCategory(data?.[0])
      getConfig(data?.[0]?.id)
    })
  }

  const getConfig = (categoryId) => {
    sendRequest('config/config/?key=카테고리노출', 'GET', null, data => {
      setShowCategory(data?.[0]?.boolean)
      if(data?.[0]?.boolean) {
        // getPortfolios(data?.[0]?.boolean ? categoryId : '')
      }
    })
  }

  const getPortfolios = (categoryId) => {
    sendRequest(`portfolio/portfolio?size=300&category=${categoryId ? categoryId : ''}`, 'GET', null, data => {
      setPortfolios(data);
      setIsLoading(false)
    })
  }

  useEffect(() => {
    getCategories()
    savePageVisit('Works')
  }, [])

  useEffect(() => {
    if(showCategory || !category?.id) {
      getPortfolios(category?.id)
    }
  }, [category])

  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  return (
    <div className={'relative'}>
      {modalOpen ? null : <Header/>}
      {isPc ?
        <div style={{marginTop: 80}}>
          <div className={'black-bg flex-start flex-grow'} style={{
            height: 'auto',
            marginTop: 12,
            paddingBottom: 5,
            marginBottom: 5,
            paddingLeft: '3vw',
            display: showCategory ? 'flex' : 'none'
          }}>
            {categories?.map((item, index) => {
              const isActive = category?.id === item?.id
              return (
                <div
                  className={`works-menu white bebas-kai ${isActive ? 'active-works-menu' : ''}`}
                  onClick={() => setCategory(item)}
                  style={{marginRight: categories?.length - 1 !== index ? '3vw' : 0}}
                >
                  {item?.name}
                </div>
              )
            })}
          </div>
          <div className={'relative width-100-vw'}>
            {!isLoading && portfolios?.length &&
              <div className={'flex-row-wo-center'}>
                <div className={'flex-1 flex-column'}>
                  {portfolios?.filter((a, i) => !(i % 2) && i !== portfolios?.length - 1).map((item, index) => {
                    const isHorizontal = index % 2 === 1

                    return (
                      <Portfolio item={item} index={index} key={`portfolio-${item?.id}-${index}`}
                                 isHorizontal={isHorizontal} navigate={navigate} setModalOpen={setModalOpen}
                                 setPortfolio={setPortfolio}/>
                    )
                  })}
                </div>
                <div className={'flex-1 flex-column'}>
                  {portfolios?.filter((a, i) => i % 2 || i === portfolios?.length - 1).map((item, index) => {
                    const isHorizontal = index % 7 < 3 || index % 7 === 4 || index % 7 === 5

                    return (
                      <Portfolio item={item} index={index} key={`portfolio-${item?.id}-${index}`}
                                 isHorizontal={isHorizontal} navigate={navigate} setModalOpen={setModalOpen}
                                 setPortfolio={setPortfolio}/>
                    )
                  })}
                </div>
              </div>
            }
          </div>
          <Modal
            isOpen={modalOpen}
            // onAfterOpen={afterOpenModal}
            onRequestClose={() => setModalOpen(false)}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <ModalComponent portfolio={portfolio} setModalOpen={setModalOpen} portfolios={portfolios}
                            setPortfolio={setPortfolio} scrollRef={scrollRef}/>
          </Modal>
          {modalOpen ?
            <div className={'modal-portfolios-wrapper width-100-vw flex-row fixed'}
                 style={{left: 0, bottom: -10, zIndex: 99999}}>
              {/*<Carousel*/}
              {/*  ref={carouselRef}*/}
              {/*  className={'custom-carousel'}*/}
              {/*  swipeable={true}*/}
              {/*  emulateTouch={true}*/}
              {/*  showThumbs={false}*/}
              {/*  showArrows={true}*/}
              {/*  showIndicators={false}*/}
              {/*  // enableSnap={false}*/}
              {/*  // renderIndicator={(clickHandler, isSelected, index) => {*/}
              {/*  //   return (*/}
              {/*  //     <span key={`dot-${index}`} className={`dot custom-dot icon-50`} style={{backgroundColor: 'transparent', marginRight: 16, zIndex: 99}}>*/}
              {/*  //       <img onClick={clickHandler}  style={{width: 31.39, height: 33.64, marginTop: 120}} src={isSelected ? require('../assets/images/works/page_on.png') : require('../assets/images/works/page_false.png')}/>*/}
              {/*  //     </span>*/}
              {/*  //   )*/}
              {/*  // }}*/}
              {/*  renderArrowPrev={(clickHandler, hasPrev, label) => {*/}
              {/*    return (*/}
              {/*      <div onClick={clickHandler} className={'absolute'} style={{left: 0, bottom: -5, zIndex: 99}}>*/}
              {/*        <img style={{height: '7vw', maxWidth: '3.5vw', backgroundColor: '#C52922'}}*/}
              {/*             src={require('../assets/images/works/new_left.png')}/>*/}
              {/*      </div>*/}
              {/*    )*/}
              {/*  }}*/}
              {/*  renderArrowNext={(clickHandler, hasPrev, label) => {*/}
              {/*    return (*/}
              {/*      <div onClick={clickHandler} className={'absolute'} style={{right: 0, bottom: -5, zIndex: 99}}>*/}
              {/*        <img style={{height: '7vw', maxWidth: '3.5vw', backgroundColor: '#000'}}*/}
              {/*             src={require('../assets/images/works/new_right.png')}/>*/}
              {/*      </div>*/}
              {/*    )*/}
              {/*  }}*/}
              {/*  showStatus={false}*/}
              {/*  autoPlay={false}*/}
              {/*  infiniteLoop={false}*/}
              {/*  centerMode={true}*/}
              {/*  centerSlidePercentage={12}*/}
              {/*  width={'100vw'}*/}
              {/*  preventMovementUntilSwipeScrollTolerance={true}*/}
              {/*  swipeScrollTolerance={2}*/}
              {/*  animationHandler={'slide'}*/}
              {/*  interval={3000}*/}
              {/*  // onChange={index => setIndex(index)}*/}
              {/*>*/}
              {/*<Slider*/}
              {/*  ref={carouselRef}*/}
              {/*  infinite={false}*/}
              {/*  dots={false}*/}
              {/*  slidesToShow={1}*/}
              {/*  slidesToScroll={1}*/}
              {/*  // speed={500}*/}
              {/*  // autoplaySpeed={300}*/}
              {/*  // autoPlay={true}*/}
              {/*  centerMode={true}*/}
              {/*  afterChange={setIndex}*/}
              {/*  vertical={false}*/}
              {/*  useTransform={true}*/}
              {/*  variableWidth={true}*/}
              {/*  rows={1}*/}
              {/*  arrows={false}*/}
              {/*  initialSlide={0}*/}
              {/*  style={{width: '100vw'}}*/}
              {/*>*/}
              <div ref={carouselRef} {...events} className={'flex-1 flex-row relative'}
                   style={{overflow: 'scroll', padding: '0 3.5vw'}}>
                {portfolios?.map((item, index) => {
                  return (
                    <ModalPortfolio item={item} index={index} setPortfolio={setPortfolio} scrollRef={scrollRef}/>
                  )
                })}
              </div>
              <div onClick={() => carouselRef.current.scrollLeft -= window.innerWidth * 0.12} className={'absolute'}
                   style={{left: 0, bottom: 3, zIndex: 99}}>
                <img style={{height: '7vw', maxWidth: '3.5vw', backgroundColor: '#C52922'}}
                     src={require('../assets/images/works/new_left.png')}/>
              </div>
              <div onClick={() => {
                carouselRef.current.scrollLeft += window.innerWidth * 0.12
              }} className={'absolute'} style={{right: 0, bottom: 3, zIndex: 99}}>
                <img style={{height: '7vw', maxWidth: '3.5vw', backgroundColor: '#000'}}
                     src={require('../assets/images/works/new_right.png')}/>
              </div>
              {/*</Slider>*/}

              {/*</Carousel>*/}
            </div>
            :
            <div ref={carouselRef}>
            </div>
          }
          {/*{image &&*/}
          {/*  <ScrollAnimation animationIn={'fadeIn'}>*/}
          {/*  <div className={'absolute flex-center'} style={{width: '100%', top: '10vw', zIndex: 9999}}>*/}
          {/*    <img style={{width: '50vw'}} src={image}/>*/}
          {/*  </div>*/}
          {/*  </ScrollAnimation>*/}
          {/*}*/}
          <div className={'width-100'} style={{marginTop: -10}}>
            <Footer/>
          </div>
        </div>
        :
        <div className={'black-bg'} style={{marginTop: 80, paddingTop: '3vw'}}>
          {/*<div>*/}
          {/*  <img style={{width: '50%'}} src={require('../assets/images/mobile/mobile_works.png')}/>*/}
          {/*</div>*/}
          <div className={'black-bg flex-start flex-grow'}
               style={{height: 75, marginBottom: 10, marginLeft: '3vw', display: showCategory ? 'flex' : 'none'}}
               align={'center'}>
            {categories?.map((item, index) => {
              const isActive = category?.id === item?.id
              return (
                <div
                  className={`mobile-works-menu white bebas-kai ${isActive ? 'mobile-active-works-menu' : ''}`}
                  onClick={() => setCategory(item)}
                  style={{marginRight: categories?.length - 1 !== index ? '8vw' : 0}}
                >
                  {item?.name}
                </div>
              )
            })}
          </div>
          <div className={'relative width-100'}>
            <div className={'flex-row-wo-center'}>
              <div className={'flex-1 flex-column'}>
                {portfolios?.slice(0, Math.floor(portfolios?.length / 2)).map((item, index) => {
                  const isHorizontal = index % 2 === 1

                  return (
                    <Portfolio item={item} index={index} key={`portfolio-${item?.id}-${index}`}
                               isHorizontal={isHorizontal} navigate={navigate} setModalOpen={setModalOpen}
                               setPortfolio={setPortfolio}/>
                  )
                })}
              </div>
              <div className={'flex-1 flex-column'}>
                {portfolios?.slice(Math.floor(portfolios?.length / 2), portfolios?.length).map((item, index) => {
                  const isHorizontal = index % 7 < 3 || index % 7 === 4 || index % 7 === 5

                  return (
                    <Portfolio item={item} index={index} key={`portfolio-${item?.id}-${index}`}
                               isHorizontal={isHorizontal} navigate={navigate} setModalOpen={setModalOpen}
                               setPortfolio={setPortfolio}/>
                  )
                })}
              </div>
            </div>
          </div>
          <div ref={carouselRef}>
          </div>
          {/*<div className={`flex-row-wo-center ${showCategory ? 'margin-top-10' : 'margin-top-54'}`}>*/}
          {/*  <div className={'flex-1 flex-column'}>*/}
          {/*    {portfolios?.map((item, index) => {*/}
          {/*      return (*/}
          {/*        <MobilePortfolio item={item} index={index} navigate={navigate}/>*/}
          {/*      )*/}
          {/*    })}*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div className={'width-100'}>
            <Footer/>
          </div>
        </div>
      }
    </div>
  )
}
